<template>
  <div class="food-details">
    <b-tabs>
      <b-tab :title="_T('Order Status')" active>
        <OrderStatus></OrderStatus>
      </b-tab>
      <b-tab :title="_T('Order Detail')">
        <OrderDescription></OrderDescription>
      </b-tab>
      <!-- <b-tab title="Messages">
        <Message></Message>
      </b-tab> -->
    </b-tabs>
  </div>
</template>
<script>
import OrderStatus from './OrderStatus'
import OrderDescription from './OrderDescription'
import { mapGetters } from 'vuex'

// import Message from './Message'
export default {
  components:{
    OrderStatus,
    OrderDescription,
    // Message
  },
  computed: {
     ...mapGetters([
      '_T'
    ]),
  }
}
</script>

<style lang="scss">
.food-details {
  background: $light-sky;
  height: 100%;
  .nav {
    padding: calc(#{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320)))
      calc(#{$px20} + (30 - 20) * ((100vw - #{$px320}) / (1920 - 320))) 0;
    border-bottom: $px2 solid $light-border;
    flex-wrap: nowrap;
    .nav-item {
      .nav-link {
        font-weight: 600;
        font-size: calc(#{$px15} + (18 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
        line-height: $px22;
        color: $light-font;
        position: relative;
        border: none;
        padding-bottom: calc(
          #{$px10} + (20 - 10) * ((100vw - #{$px320}) / (1920 - 320))
        );
        padding-top: 0;
        .msg-notification {
          position: absolute;
          right: 32%;
          top: -30%;
          transition: all 0.5s ease;
          i {
            color: $color-primary;
            font-size: $px9;
          }
        }
        &.active,
        &.show {
          .msg-notification {
            opacity: 0;
            transition: all 0.5s ease;
          }
        }
        &:hover,
        &:focus {
          border: none !important;
        }
        &:after {
          position: absolute;
          content: '';
          width: 100%;
          height: $px4;
          background-color: $transparent;
          bottom: -$px1;
          left: 0;
          border-top-left-radius: $px30;
          border-top-right-radius: $px30;
        }
      }
    }
  }
  .nav-tabs {
    .nav-link {
      &.active {
        border: none;
        color: $color-primary !important;
        background-color: $transparent;
        &:after {
          background-color: $color-primary !important;
        }
      }
    }
    .nav-item {
      width: 100%;
      text-align: center;
      &.show {
        .nav-link {
          border: none;
          color: $color-primary !important;
          background-color: $transparent;
          &:after {
            background-color: $color-primary !important;
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .food-details {
    .nav-tabs {
      .nav-item {
                &:nth-child(3) {
                    display: none;
                }
            }
    }
}
}
</style>
